/** 从 GeoJSON 计算经纬度包围盒 */
export function getGeoBounds(geojson) {
  let minLng = Infinity;
  let maxLng = -Infinity;
  let minLat = Infinity;
  let maxLat = -Infinity;

  function walk(coords) {
    if (typeof coords[0] === "number") {
      const lng = coords[0];
      const lat = coords[1];
      if (lng < minLng) minLng = lng;
      if (lng > maxLng) maxLng = lng;
      if (lat < minLat) minLat = lat;
      if (lat > maxLat) maxLat = lat;
      return;
    }
    coords.forEach(walk);
  }

  (geojson.features || []).forEach(f => {
    if (f.geometry && f.geometry.coordinates) {
      walk(f.geometry.coordinates);
    }
  });

  return { minLng, maxLng, minLat, maxLat };
}

export function getFeatureCenter(feature) {
  const p = (feature && feature.properties) || {};
  if (p.centroid && p.centroid.length === 2) return p.centroid;
  if (p.center && p.center.length === 2) return p.center;
  const b = getGeoBounds({ features: [feature] });
  return [(b.minLng + b.maxLng) / 2, (b.minLat + b.maxLat) / 2];
}
